var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7080_118513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7080_118513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.998 28.834C32.2651 28.8315 31.5518 29.0714 30.9694 29.5164C30.387 29.9614 29.968 30.5865 29.7779 31.2944C29.5877 32.0023 29.6369 32.7532 29.9179 33.4301C30.1989 34.1071 30.6958 34.6722 31.3314 35.0373V37.3982C31.3313 37.517 31.3665 37.6333 31.4325 37.7321C31.4985 37.831 31.5924 37.908 31.7022 37.9535C31.812 37.999 31.9329 38.0109 32.0495 37.9877C32.1661 37.9645 32.2732 37.9073 32.3572 37.8232L32.998 37.1832L33.6389 37.8232C33.7229 37.9073 33.83 37.9645 33.9466 37.9877C34.0631 38.0109 34.184 37.999 34.2938 37.9535C34.4036 37.908 34.4975 37.831 34.5635 37.7321C34.6295 37.6333 34.6647 37.517 34.6647 37.3982V35.0373C35.3002 34.6722 35.7972 34.1071 36.0782 33.4301C36.3591 32.7532 36.4084 32.0023 36.2182 31.2944C36.028 30.5865 35.6091 29.9614 35.0267 29.5164C34.4442 29.0714 33.731 28.8315 32.998 28.834Z",
    fill: "#3374B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 32.1667C27.999 31.2887 28.2294 30.4259 28.6682 29.6653C29.1069 28.9048 29.7384 28.2734 30.4989 27.8347C31.2595 27.396 32.1223 27.1656 33.0003 27.1667C33.8783 27.1678 34.7405 27.4003 35.5 27.8408V22.1667C35.4987 21.062 35.0593 20.003 34.2781 19.2218C33.497 18.4407 32.438 18.0013 31.3333 18H24.6667C23.562 18.0013 22.503 18.4407 21.7218 19.2218C20.9407 20.003 20.5013 21.062 20.5 22.1667V32.1667C20.5013 33.2713 20.9407 34.3304 21.7218 35.1115C22.503 35.8926 23.562 36.332 24.6667 36.3333H29.6667V35.8833C29.1426 35.4163 28.7231 34.8438 28.4359 34.2032C28.1487 33.5627 28.0001 32.8687 28 32.1667ZM24.6667 21.3333H31.3333C31.5543 21.3333 31.7663 21.4211 31.9226 21.5774C32.0789 21.7337 32.1667 21.9457 32.1667 22.1667C32.1667 22.3877 32.0789 22.5996 31.9226 22.7559C31.7663 22.9122 31.5543 23 31.3333 23H24.6667C24.4457 23 24.2337 22.9122 24.0774 22.7559C23.9211 22.5996 23.8333 22.3877 23.8333 22.1667C23.8333 21.9457 23.9211 21.7337 24.0774 21.5774C24.2337 21.4211 24.4457 21.3333 24.6667 21.3333ZM24.6667 24.6667H31.3333C31.5543 24.6667 31.7663 24.7545 31.9226 24.9107C32.0789 25.067 32.1667 25.279 32.1667 25.5C32.1667 25.721 32.0789 25.933 31.9226 26.0893C31.7663 26.2455 31.5543 26.3333 31.3333 26.3333H24.6667C24.4457 26.3333 24.2337 26.2455 24.0774 26.0893C23.9211 25.933 23.8333 25.721 23.8333 25.5C23.8333 25.279 23.9211 25.067 24.0774 24.9107C24.2337 24.7545 24.4457 24.6667 24.6667 24.6667ZM27.1667 29.6667H24.6667C24.4457 29.6667 24.2337 29.5789 24.0774 29.4226C23.9211 29.2663 23.8333 29.0543 23.8333 28.8333C23.8333 28.6123 23.9211 28.4004 24.0774 28.2441C24.2337 28.0878 24.4457 28 24.6667 28H27.1667C27.3877 28 27.5996 28.0878 27.7559 28.2441C27.9122 28.4004 28 28.6123 28 28.8333C28 29.0543 27.9122 29.2663 27.7559 29.4226C27.5996 29.5789 27.3877 29.6667 27.1667 29.6667Z",
    fill: "#3374B9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7080_118513",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.454902 0 0 0 0 0.72549 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7080_118513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7080_118513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7080_118513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicIcon);
export default __webpack_public_path__ + "static/media/topicIcon.2af76222c892f687fcdd553522ab157d.svg";
export { ForwardRef as ReactComponent };